import React from 'react';
import { createContext } from 'react';
import { AdministratorsQueryVariables } from 'schema/serverTypes';

export type AdministratorsQueryContext = AdministratorsQueryVariables | undefined;

export const QueryVariablesContext = createContext<AdministratorsQueryContext>(undefined);

export interface QueryContextProviderProps {
  variables: AdministratorsQueryContext;
  children: React.ReactNode;
}

export const QueryContextProvider = (props: QueryContextProviderProps) => {
  const { children, variables } = props;
  return (
    <QueryVariablesContext.Provider value={variables}>{children}</QueryVariablesContext.Provider>
  );
};
